/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemTileCarousel_item = {
    readonly serviceId: string | null;
    readonly seller: {
        readonly serviceId: string | null;
    } | null;
    readonly " $refType": "PdpRespSimilarItemTileCarousel_item";
};
export type PdpRespSimilarItemTileCarousel_item$data = PdpRespSimilarItemTileCarousel_item;
export type PdpRespSimilarItemTileCarousel_item$key = {
    readonly " $data"?: PdpRespSimilarItemTileCarousel_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemTileCarousel_item">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "PdpRespSimilarItemTileCarousel_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "seller",
      "storageKey": null,
      "args": null,
      "concreteType": "Seller",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ]
    }
  ]
};
})();
(node as any).hash = '2755d9fcebcdb0e27db5597d37ba4f56';
export default node;
